<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4288 16.25H14.6788V13.75C14.6792 13.4186 14.811 13.1008 15.0453 12.8665C15.2797 12.6321 15.5974 12.5003 15.9288 12.5H17.1788V11.25H14.6788V10H17.1788C17.5102 10.0004 17.828 10.1322 18.0623 10.3665C18.2966 10.6009 18.4285 10.9186 18.4288 11.25V12.5C18.4285 12.8314 18.2966 13.1491 18.0623 13.3835C17.828 13.6178 17.5102 13.7496 17.1788 13.75H15.9288V15H18.4288V16.25Z"
      fill="var(--color, #04785E)"
    />
    <path
      d="M12.1788 13.75H9.67883C9.34743 13.7496 9.02971 13.6178 8.79537 13.3835C8.56103 13.1491 8.42921 12.8314 8.42883 12.5V6.25C8.42916 5.91858 8.56097 5.60083 8.79532 5.36648C9.02966 5.13213 9.34741 5.00033 9.67883 5H12.1788C12.5103 5.00033 12.828 5.13213 13.0624 5.36648C13.2967 5.60083 13.4285 5.91858 13.4288 6.25V12.5C13.4285 12.8314 13.2966 13.1491 13.0623 13.3835C12.828 13.6178 12.5102 13.7496 12.1788 13.75ZM9.67883 6.25V12.5H12.1788V6.25H9.67883Z"
      fill="var(--color, #04785E)"
    />
    <path
      d="M7.17883 13.75H3.42883C3.09743 13.7496 2.77971 13.6178 2.54537 13.3835C2.31103 13.1491 2.17921 12.8314 2.17883 12.5V6.25C2.17916 5.91858 2.31097 5.60083 2.54531 5.36648C2.77966 5.13213 3.09741 5.00033 3.42883 5H7.17883V6.25H3.42883V12.5H7.17883V13.75Z"
      fill="var(--color, #04785E)"
    />
  </svg>
</template>
